import script from "./Snackbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Snackbar.vue?vue&type=script&setup=true&lang=ts"

import "./Snackbar.vue?vue&type=style&index=0&id=166d3ca2&lang=scss"

const __exports__ = script;

export default __exports__